module.exports = __webpack_public_path__ + "img/gyljr.3408abca.png";